import { configureStore } from '@reduxjs/toolkit';
import { strapiApi, gatewayApi } from './Apis';
import authReducer from './slices/authSlice';
import iframeParamsReducer from './slices/iframeParamsSlice';

// Create the Redux store
export const store = configureStore({
  reducer: {
    [strapiApi.reducerPath]: strapiApi.reducer,
    [gatewayApi.reducerPath]: gatewayApi.reducer,
    auth: authReducer,
    iframeParams: iframeParamsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(strapiApi.middleware)
      .concat(gatewayApi.middleware),
  devTools: import.meta.env.MODE !== 'production',
});

// NOTE: setupListeners is intentionally NOT called here to prevent automatic
// refetching on focus/reconnect/online events. This was causing the iframe
// to continuously refresh and spam postMessage events to the parent window.
// If you need manual refetching, use the refetch functions from the hooks.

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
